<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="rSRecord">
      <div slot="toolbar">
        <el-button type="primary" @click="$refs.editRSRecord.open(0)">新建</el-button>
        <el-button type="primary" @click="exportExcel">导出</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="建议人">
            <el-input v-model.trim="filter.proposer" clearable/>
          </vm-search>
          <vm-search label="建议人工号">
            <el-input v-model.trim="filter.proposerNo" clearable/>
          </vm-search>
          <vm-search label="建议人部门">
            <el-input v-model.trim="filter.department" clearable/>
          </vm-search>
          <vm-search label="标题">
            <el-input v-model.trim="filter.proposalTitle" clearable/>
          </vm-search>
          <vm-search label="建议类型">
            <el-select v-model.trim="filter.proposalType" clearable placeholder="请选择">
              <el-option
                  v-for="item in constant.toSelect(constant.proposalTypes)"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </vm-search>
          <vm-search label="建议日期">
            <div class="block">
              <el-date-picker
                  v-model="filter.proposalTimeBegin"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 135px"
                  placeholder="选择开始日期"/>
            </div>
            <div class="block">
              <el-date-picker
                  v-model="filter.proposalTimeEnd"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 135px"
                  placeholder="选择结束日期"/>
            </div>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="proposer" align="center" label="建议人"/>
      <el-table-column prop="proposerNo" align="center" label="建议人工号"/>
      <el-table-column prop="department" align="center" label="建议人部门"/>
      <el-table-column prop="proposalTitle" align="center" label="标题"/>
      <el-table-column prop="proposalType" align="center" label="建议类型">
        <template slot-scope="scope">
          <span>{{constant.proposalTypes[scope.row.proposalType]}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="proposalTime" align="center" label="建议日期">
        <template slot-scope="scope">
          <span>{{scope.row.proposalTime.slice(0,10)}}</span>
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="120px">
        <template slot-scope="scope">
          <el-button type="info" @click="$refs.editRSRecord.open(scope.row)">编辑</el-button>
          <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <r-s-record-edit ref="editRSRecord" @save-success="getList(1)"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "@/util/constant";
  import RSRecordEdit from "@/views/information/RSRecord/RSRecordEdit";
  export default {
    name: "RSRecordList",
    components: {RSRecordEdit, VmTable,VmSearch},
    data() {
      return {
        constant,
        idList: "",
        exportLoading: false,
        filter: {
          proposer: "",
          proposerNo: "",
          department: "",
          proposalTitle: "",
          proposalTimeBegin: "",
          proposalTimeEnd: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      //导出
      exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic","rSRecord/exportImgRSR", this.exportWHL)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","rSRecord",row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>

<style scoped>

</style>
